import template from './client.html';
import controller from './client.controller';

let clientComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default clientComponent;
